const initialState = {
  bannerList: [],
  categoryList: [],
  showList: [],
  unionConfig: {},
  homeState: null,
};

// 首页
export default function receiveHomeDate(state = initialState, action) {
  switch (action.type) {
  case 'BANNER_LIST':
    return { ...state, bannerList: action.payload };
  case 'CATEGOYR_LIST':
    return { ...state, categoryList: action.payload };
  case 'SHOW_LIST':
    return { ...state, showList: action.payload };
  case 'UNION_CONFIG':
    return { ...state, showList: action.payload };
  case 'SAVE_HOME_STATE':
    return { ...state, homeState: action.payload };
  case 'CLEAR_HOME_STATE':
    return { ...state, homeState: null };
  default:
    return state;
  }
}